import { FC } from 'react';
import { useQuery } from '@tanstack/react-query'
import { Body1, Card, CardHeader, CardPreview, Link as FluentLink, Toolbar, Tooltip, Text, Spinner } from '@fluentui/react-components';
import DefaultJobPosting from './jobs/DefaultJobPosting';
import { bind } from '@react-rxjs/core';
import { isAuthorized$ } from './oauth/oauth';
import { nodeServer } from './constants';
import LinkRouter from './LinkRouter';

interface JobsProps {

}

interface IJob {
	id?: number;
	type: number;
	title: string;
	link: string;
	content: string;
	expires: Date;
	created: Date;
	ownerId: number;
}


const [useIsAuthorized] = bind(isAuthorized$, isAuthorized$.value);

const Jobs: FC<JobsProps> = () => {

	const { data: jobs } = useQuery({
		queryKey: ['jobs'],
		refetchOnWindowFocus: false,
		queryFn: async () => {
			let url = nodeServer + `jobs/current`;
			const res = await fetch(url);
			if (!res.ok) {
				throw new Error('Network response was not ok')
			}
			const jobs: IJob[] = await res.json();

			return jobs;
		}
	});

	// const { data: myJobs } = useQuery({
	// 	queryKey: ['myJobs'], 
	// 	refetchOnWindowFocus: false, 
	// 	queryFn: async () => {
	// 		if (accessTokenInfo$.value === null || accessTokenInfo$.value.accessToken === null) {
	// 			return [] as IJob[];
	// 		}
	// 		let headers = new Headers();
	// 		headers.append('Content-Type', 'application/json');
	// 		headers.append('Authorization', 'Bearer ' + accessTokenInfo$.value.accessToken);
	// 		let url = nodeServer + `jobs/me`;
	// 		const res = await fetch(url, {headers: headers});
	// 		if (!res.ok) {
	// 			throw new Error('Network response was not ok')
	// 		}
	// 		const jobs: IJob[] = await res.json();

	// 		return jobs;
	// 	}
	// });

	const isAuthorized = useIsAuthorized();

	return (
		<>
			{isAuthorized ? (
				<>
					<Toolbar>
						<Tooltip
							relationship='description'
							withArrow
							content="Create or Edit Job Postings...">
							<LinkRouter as="ToolbarButton" appearance="primary" href='/jobs/edit'>Add/Edit Job Postings</LinkRouter>
						</Tooltip>
						{/* <Popover
							withArrow
							trapFocus
							open={open === "first"}
							onOpenChange={(_, data) => setOpen(data.open ? "first" : undefined)}
						>
							<PopoverTrigger disableButtonEnhancement>
								<ToolbarButton aria-label="Edit My Posting" >Edit My Posting...</ToolbarButton>
							</PopoverTrigger>
							<PopoverSurface>
								<MenuList>
									{myJobs === undefined ? <></> : myJobs.map(x=>
										(<LinkRouter key={x.id} as="MenuItemLink"  href={'/jobs/edit/' + x.id}>{x.title}</LinkRouter>)
									)}
									
								</MenuList>
							</PopoverSurface>
						</Popover> */}

					</Toolbar>

				</>
			) : (
				<Card style={{ marginBottom: 10 }}>
					<CardHeader header={<Body1 ><b>Posting a Job</b></Body1>} />
					<CardPreview style={{ padding: 5 }}>
						<Body1> Members can create and manage their own job postings free of charge.  Either <FluentLink href='/membership'>become a member</FluentLink>
							&nbsp;or email the webmaster at <FluentLink href="mailto:webmaster@2yc3.org?subject=Job%20Posting%20Request">webmaster@2yc3.org</FluentLink> for sponsorship pricing.
						</Body1>
					</CardPreview>
				</Card>
			)}

			<div style={{ display: 'flex', flexDirection: 'column' }}>
				<h1>Current Jobs</h1>
				{jobs === undefined ? (<><Spinner></Spinner></>) : (
					jobs.length === 0 ? (<><Text>There are no jobs available at the moment.</Text></>) :
						(
							jobs.map((v) => {

								switch (v.type) {
									case 0:
										return (<><DefaultJobPosting key={v.id} {...v} /></>);
									default:
										return (<><div key={v.id}>test</div></>);
								}
							}))
				)}
			</div>

		</>
	);
};

export default Jobs;
